<template>
    <div>
        <div id="mainhold">
            <div id="leftcolumn" class="cols">Submitted Verifications<br>
                <div v-for="(doc, index) in docs" :key="index">

                </div>
            </div>
            <div id="rightcolumn" class="cols"></div>
                <div class="amTealregular" @click="showLabel(labellink)">Label Link<br>{{labellink}}</div>
                <div class="spacer"></div>
                <div class="amGrayregular">Cost: ${{shipcost}} | Tracking: {{tracking_number}} | LabelID: {{label_id}}</div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/functions'
import 'firebase/firestore'
export default {
    name: "verify",
    data(){
        return {
            userID: "",
            docs: [],
            doc: {},
        }
    },
    created(){
        firebase.auth().onAuthStateChanged(user => {
            if (user){
                this.userID = firebase.auth().currentUser.uid
                this.fetchDocs()
            }
        })
        
    },
    methods: {
        fetchDocs(){
            const data = {
                userID: this.userID
            }
            const fetchver = firebase.functions().httpsCallable('fetchVerifiable')
            fetchver(data).then(result => {
                if (result){
                    console.log(result)
                }
            }).catch(err => {
                console.log(err)
            })
        }
    }
}
</script>


<style scoped>

.mainwrap {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
    text-align: left;
}

.spacer {
    width: 100%;
    height: 20px;
    float: left;
    clear: right;
}
    #mainhold {
    width: 100%;
    height: 55vh;
    background-color: white;
    position: relative;
    overflow: scroll;
    position: relative;
}

.cpointer {
    cursor: pointer;
}

.btn {
    width: auto;
    height: auto;
    padding: 2%;
    border-radius: 2vmin;
    text-align: center;
    color: white;
    float:right;
    clear: right;
}

#rightcol {
    width: auto;
    height: auto;
    position: fixed;
    top: 0;
    margin-top: 300px;
    right: 0;
    margin-left: 50vw;
}

.imgHolder {
    width: 50px;
    height: 50px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
    clear: right;
}

.imgHolder2 {
    width: 250px;
    height: 250px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
    clear: right;
}

.wrapper {
    width: 60%;
    float: left;
    clear: right;
    height: auto;
    text-align: right;
    margin-left: 20px;
}

.instyle {
    width: 100%;
    height: 50px;
    border-style: solid;
    background-color: azure;
    padding: 1%;
    float: left;
    clear: right;
    margin-bottom: 5px;
}

.wrapperr {
    width: 60%;
    float: left;
    clear: right;
    height: auto;
    text-align: left;
    margin-left: 20px;
}

.listingholder {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
    padding: 2%;
    margin-bottom: 5px;
}

.cols {
    width: 50%;
    height: auto;
    float: left;
    clear: right;
    padding: 5%;
    border-right-color: #00a89d;
    border-right-width: 2px;
    overflow: scroll;
}
</style>